import React, { useEffect } from 'react';
import { Route, useLocation } from 'react-router-dom';
import AuthProvider from './context/auth-context-aem';
import { useRoute } from './context/route-context';

function PrivateRoute({ component: Component, title, banner, ...rest }) {
  document.title = `${title} | ${banner}`;

  const location = useLocation();
  const { saveRouteData } = useRoute();

  useEffect(() => {
    saveRouteData({ currentPage: title });
  }, [location]);

  return (
    <AuthProvider>
      <Route {...rest} render={(props) => <Component {...props} />} />
    </AuthProvider>
  );
}

export default PrivateRoute;
